module.exports = __webpack_public_path__ + "fonts/BaskervilleBT-Bold.a9910543.woff";